import { chat } from '../../api'

const state = {
  chat: {
    buttons: [],
    images: [],
    reply: ''
  }
}

const getters = {
  getChat: state => state.chat
}

const mutations = {
  SET_CHAT (state, payload) {
    state.chat = payload
  }
}

const actions = {
  CHAT_BOT ({ commit }, payload) {
    return chat.chatbot(payload)
      .then((data) => commit('SET_CHAT', data.response))
  }
}

export default {
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
